window.onload = function() {


  document.querySelectorAll('.slidercustom-product-thumbs > li').forEach(function(item) {
    item.addEventListener('click', function() {
      const ariaLabel = this.getAttribute('aria-label'); // ejemplo: "3 / 6"
      const firstNumber = ariaLabel.split('/')[0].trim(); // ejemplo: "3"
  
      // Construimos el aria-label objetivo
      const targetAriaLabel = `Go to slide ${firstNumber}`;
  
      // Buscamos el span correspondiente y disparamos el click
      const targetSlide = document.querySelector(`.container--slider-product .swiper-pagination > span[aria-label="${targetAriaLabel}"]`);
  
      if (targetSlide) {
        targetSlide.click();
      } else {
        console.warn('No se encontró el slide con:', targetAriaLabel);
      }
    });
  });


 // let activeSlider = document.querySelector("#product-grid > li")
//swiper.slideNext();
//swiper.slidePrev();

  // Agrega eventos de hover a cada <li>
// Inicializa todos los sliders con tu configuración
  const swipers = [];
  document.querySelectorAll('.images-slider').forEach((el) => {
    const swiper = new Swiper(el, {
      spaceBetween: 0,
      centeredSlides: true,
      autoplay: {
        delay: 20000000, // Prácticamente desactivado
        disableOnInteraction: false,
      },
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
    });
  
    swipers.push({ el, swiper });
  });

  // Asocia hover en cada <li> para avanzar y retroceder
  document.querySelectorAll('#product-grid > li > a.hovered').forEach((li) => {
    li.addEventListener('mouseenter', () => {
      console.log("mouse")
      const slider = li.parentNode.querySelector('.images-slider');
      const swiperObj = swipers.find(obj => obj.el === slider);
      if (swiperObj) swiperObj.swiper.slideNext();
    });
  
    li.addEventListener('mouseleave', () => {
      const slider = li.parentNode.querySelector('.images-slider');
      const swiperObj = swipers.find(obj => obj.el === slider);
      if (swiperObj) swiperObj.swiper.slidePrev();
    });
  });

  
  let swiperProduct = new Swiper(".container--slider-product", {
  spaceBetween: 0,
  centeredSlides: true,
  autoplay: {
    delay: 20000000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  });
  
  let swiperProductThumb = new Swiper(".container--slider-product-thumbs", {
    spaceBetween: 25,      
    slidesPerView: 5,
    autoplay: {
      delay: 20000000,
      disableOnInteraction: false,
    },    
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {     
    768: {
      spaceBetween: 65,   
    },   
  }
  });

 
let attempts = 0;
const maxAttempts = 20;
let lastTableHTML = "";
let changesApplied = false;


const loading = document.createElement("span");
let isSoldOut = false;
loading.innerText = "Loading . . .";
loading.className = "wholesale-loading";

const loadingContainer = document.querySelector(".container-acordeon-price.wholesale .price__container");
  if(loadingContainer)  isSoldOut = loadingContainer.dataset.available
 
if (loadingContainer && isSoldOut == "true") {
  loadingContainer.prepend(loading);
}

const interval = setInterval(() => {
  const container = document.querySelector("product-info > div > form > #wcp_vd_table");
  const priceElement = document.querySelector(".price-item.price-item--regular.wpd-processed");

  if (container && container.innerHTML.trim() !== "" && priceElement) {
    const table = container.querySelector(".wrapper-form-hidden table");
    const span = container.querySelector("b > span");

    if (!table || !span) return;

    const thFirst = table.querySelector("tbody > tr > th:first-of-type");
    const thLast = table.querySelector("tbody > tr > th:last-of-type");

    if (!thFirst || !thLast) return;

    // Verifica si la tabla cambió (se re-renderizó)
    const currentTableHTML = table.innerHTML.trim();
    const tableChanged = currentTableHTML !== lastTableHTML;

    if (tableChanged || !changesApplied) {
      // Actualizamos encabezados y texto
      thFirst.innerText = "Units:";
      thLast.innerText = "Cost:";
      span.innerHTML = 'Apply for a wholesale account <a href="/pages/create-wholesale-account">here</a>';

      // Elimina fila previa si ya existía
      table.querySelectorAll("tr.inserted-row").forEach(row => row.remove());

      const clonedPrice = priceElement.cloneNode(true);
      const compareAtPrice = clonedPrice.querySelector(".wpd-ext-compare-at-price");
      if (compareAtPrice) compareAtPrice.remove();
      const priceText = clonedPrice.textContent.trim();

      const newRow = table.insertRow(1);
      newRow.classList.add("inserted-row");
      newRow.innerHTML = `<td>1 - 99</td><td>Columna 2</td><td>${priceText}</td>`;

      // Copia la tabla al nuevo contenedor
      const newContainer = document.querySelector(".container-acordeon-price.wholesale .price__container");
      if (newContainer) {
        const existingClone = newContainer.querySelector("#wcp_vd_table");
        if (existingClone) existingClone.remove();

        const clonedTable = container.cloneNode(true);
        newContainer.appendChild(clonedTable);

        // Remueve el loading si está presente
        if (loading && loading.parentElement) {
          loading.remove();
        }

        console.log("cloned");
      }

      lastTableHTML = currentTableHTML;
      changesApplied = true;
    }
  }

  attempts++;
  if (attempts >= maxAttempts) {
    clearInterval(interval);
    if (loading && loading.parentElement) {
      loading.remove(); // asegurar que el loading se elimine al final
    }
    console.warn("Se detuvo tras muchos intentos.");
  }
}, 800);





  

  let thumbQty = document.querySelectorAll(".thumbnail-list > li").length
  let mainImageHeight;
  let newHeightThumb;

  /*
  if(thumbQty > 5){
    mainImageHeight = document.querySelector(".product__media-list.contains-media > li:first-child img").clientHeight
    newHeightThumb = (mainImageHeight / thumbQty) * 0.9 
    
    document.querySelectorAll(".thumbnail-list > li").forEach(item => {
      item.style.height = `${newHeightThumb}px`;
      item.style.width = `${newHeightThumb}px`;
    });   
    window.onresize = function() {
      
       mainImageHeight = document.querySelector(".product__media-list.contains-media > li.is-active img").clientHeight
       newHeightThumb = (mainImageHeight / thumbQty) * 0.9 
      
       document.querySelectorAll(".thumbnail-list > li").forEach(item => {
         item.style.height = `${newHeightThumb}px`;
         item.style.width = `${newHeightThumb}px`;
       });
    };
  }
*/

  let templateProduct = document.querySelector("body.template-product > main > .shopify-section > section > .page-width > .product > .grid__item.product__media-wrapper")
  if(templateProduct) templateProduct.style.opacity = 1
  
}; /* END ON READY */


